import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './Button';
import { Tag } from './Tag';

export interface LessonCardProps {
  imgSrc: string;
  type: 'lesson' | 'pre-quiz';
  status?: LessonCardStatus;
  title: string;
  position?: number;
  subtitle?: string;
  buttonText?: string;
  buttonIcon?: string;
  onClick?: () => void;
  href?: string;
}

export type LessonCardStatus = 'current' | 'blocked' | 'done';

export const LessonCard: React.FC<LessonCardProps> = (props) => {
  const __ = useTranslation().t;

  if (props.type === 'pre-quiz') {
    return <PreQuizCard {...props} />;
  }
  const { status, title, position, subtitle, buttonText, onClick, imgSrc, href } = props;

  const onCardClick = () => {
    if (status === 'blocked' || !href) {
      return;
    }
    window.location.href = href;
  };

  const LessonTag = () => {
    if (status === 'blocked') {
      return <Tag icon="lock" shape="vertical-badge" variant="black-medium" />;
    }
    if (status === 'done') {
      return <Tag icon="check" shape="vertical-badge" variant="green-main" />;
    }
    return <></>;
  };
  return (
    <div
      className={classnames('oe-lesson-card', `oe-lesson-card-${status}`)}
      onClick={onClick || onCardClick}
    >
      <LessonTag />
      <div className="oe-lesson-card-top">
        <img src={imgSrc} alt={title} />
      </div>
      <div className="oe-lesson-card-body">
        <h6>{subtitle}</h6>
        <h2>{__('lessonNumber', { number: position })}</h2>
      </div>
      {status === 'current' && (
        <div className="oe-lesson-card-btn-wrapper">
          <Button label={buttonText || ''} onClick={onClick} href={href} size="lg" />
        </div>
      )}
    </div>
  );
};

const PreQuizCard: React.FC<LessonCardProps> = (props) => {
  const { title, buttonText, onClick, imgSrc } = props;
  return (
    <div className="oe-lesson-card oe-lesson-card-pre-quiz">
      <div className="oe-lesson-card-top">
        <img src={imgSrc} alt={title} />
      </div>
      <div className="oe-lesson-card-body">
        <h2>{title}</h2>
        <Button
          label={buttonText || ''}
          onClick={onClick}
          size="lg"
          variant="subtle"
          icon="arrow-right"
        />
      </div>
    </div>
  );
};
